import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { TemaProvider } from "./lib/tema";
import App from "./App";
import { BarraVerComo } from "./componentes/BarraVerComo";
import "./index.css";

// A barra do «ver como» (000335) mora AO LADO das rotas, e não dentro de uma:
// ela está em toda tela, com o «Voltar ao normal», e nenhuma tela precisa
// lembrar dela.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <TemaProvider>
        <AuthProvider>
          <App />
          <BarraVerComo />
        </AuthProvider>
      </TemaProvider>
    </BrowserRouter>
  </StrictMode>,
);
